import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const PlusIcon = ({ size, deg, color }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, deg: deg, color: color },
    React.createElement("path", { fillRule: "evenodd", d: "M10 2a.75.75 0 0 1 .75.75l-.001 6.5h6.501a.75.75 0 1 1 0 1.5h-6.501l.001 6.5a.75.75 0 1 1-1.5 0l-.001-6.5H2.75a.75.75 0 1 1 0-1.5h6.499l.001-6.5A.75.75 0 0 1 10 2z" })));
export const Plus = iconGenerator(PlusIcon);
//# sourceMappingURL=Plus.js.map